import { c as _c } from "react/compiler-runtime";
import { CLASSIFICATIONS } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatTimestampToMonthYear } from "@/helpers/Helpers";
import ProfileNameWithAiMarker from "@/components/common/profile/ProfileNameWithAiMarker";
import UserCICTypeIconWrapper from "@/components/user/utils/user-cic-type/UserCICTypeIconWrapper";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
import UserPageClassificationWrapper from "./classification/UserPageClassificationWrapper";
import UserPageHeaderNameWrapper from "./UserPageHeaderNameWrapper";
export default function UserPageHeaderName(t0) {
  const $ = _c(21);
  const {
    profile,
    canEdit,
    mainAddress,
    level,
    profileEnabledAt,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  let t2;
  if ($[0] !== mainAddress || $[1] !== profile.display || $[2] !== profile.handle) {
    const getDisplayName = () => {
      if (profile.handle) {
        return profile.handle;
      }
      if (profile.display) {
        return profile.display;
      }
      if (mainAddress.endsWith(".eth")) {
        return mainAddress;
      }
      return mainAddress;
    };
    t2 = getDisplayName();
    $[0] = mainAddress;
    $[1] = profile.display;
    $[2] = profile.handle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const displayName = t2;
  let t3;
  if ($[4] !== profileEnabledAt) {
    t3 = profileEnabledAt ? formatTimestampToMonthYear(new Date(profileEnabledAt).getTime()) : null;
    $[4] = profileEnabledAt;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const profileEnabledLabel = t3;
  const showTitle = variant !== "meta";
  const showMeta = variant !== "title";
  const t4 = showTitle && showMeta ? "tw-space-y-2" : "";
  let t5;
  if ($[6] !== canEdit || $[7] !== displayName || $[8] !== level || $[9] !== profile || $[10] !== showTitle) {
    t5 = showTitle && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2"><UserPageHeaderNameWrapper profile={profile} canEdit={canEdit}><ProfileNameWithAiMarker classification={profile.classification} markerClassName="tw-text-base md:tw-text-lg"><span className="tw-break-all tw-text-left tw-text-xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-white md:tw-text-2xl">{displayName}</span></ProfileNameWithAiMarker></UserPageHeaderNameWrapper>{profile.handle && <div className="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center xl:tw-mt-1"><UserCICTypeIconWrapper profile={profile} /></div>}<UserCICAndLevel level={level} size={UserCICAndLevelSize.SMALL} /><DropAuthorBadges profile={profile} tooltipIdPrefix="profile-author-badges" /></div>;
    $[6] = canEdit;
    $[7] = displayName;
    $[8] = level;
    $[9] = profile;
    $[10] = showTitle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== canEdit || $[13] !== profile || $[14] !== profileEnabledLabel || $[15] !== showMeta) {
    t6 = showMeta && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1"><UserPageClassificationWrapper profile={profile} canEdit={canEdit}><div className="tw-block tw-text-sm tw-font-medium tw-leading-4 tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out hover:tw-text-white">{CLASSIFICATIONS[profile.classification].title}</div></UserPageClassificationWrapper>{profileEnabledLabel && <span className="tw-text-iron-600 sm:tw-text-iron-700">•</span>}{profileEnabledLabel && <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-500" suppressHydrationWarning={true}>Profile enabled: {profileEnabledLabel}</p>}</div>;
    $[12] = canEdit;
    $[13] = profile;
    $[14] = profileEnabledLabel;
    $[15] = showMeta;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}